import { PortalRequest as request } from "@/utils/request";
import md5 from "js-md5";

export const getCompanyListByKeyword = (word) => {
  return request({
    url: "https://dev.jfh.com/jfhrm/buinfo/searchInfoV2",
    method: "get",
    params: {
      word,
    },
  });
};

// 用户信息
export const getUserRole = () => {
  return request({
    url: "https://dev.jfh.com/cas/menu/getRole",
    method: "get",
  });
};

export const getCompanyInfo = (compId) => {
  return request({
    url: "https://dev.jfh.com/jfhrm/buinfo/baseinfoV2",
    method: "get",
    params: {
      compId,
    },
  });
};

export const getUserInfo = () => {
  return request({
    url: "https://rest-dev.jfh.com/prt-citystation/user/info",
    method: "post",
  });
};

const secret = "0cc175b9c0f1b6a831c399e269772661";
const prefix = "https://rest.jfh.com";

export const getCaseList = ({ current, size }, caseName) => {
  const TIMESTAMP = Math.trunc(new Date().getTime() / 1000);
  return request({
    url: `${prefix}/dat-portal/api/search/queryDwaCases`,
    method: "post",
    headers: { SECRET: md5(secret + TIMESTAMP), TIMESTAMP },
    data: {
      pageNum: current,
      pageSize: size,
      caseName: caseName,
    },
  });
};

export const getProjectList = ({ current, size }, projectName) => {
  const TIMESTAMP = Math.trunc(new Date().getTime() / 1000);
  return request({
    url: `${prefix}/dat-portal/api/search/queryDwaProject`,
    method: "post",
    headers: { SECRET: md5(secret + TIMESTAMP), TIMESTAMP },
    data: {
      pageNum: current,
      pageSize: size,
      projectName: projectName,
    },
  });
};

export const getJfhDicts = (levelCodes) => {
  const TIMESTAMP = Math.trunc(new Date().getTime() / 1000);
  return request({
    url: `${prefix}/dat-portal/api/base/dict/queryBaseDict`,
    method: "get",
    headers: { SECRET: md5(secret + TIMESTAMP), TIMESTAMP },
    params: {
      levelCodes: levelCodes.join(","),
    },
  });
};

export const getLevelCodes = (baseCode) => {
  const TIMESTAMP = Math.trunc(new Date().getTime() / 1000);
  return request({
    url: `${prefix}/dat-portal/api/base/dict/queryLevelCodes`,
    method: "get",
    headers: { SECRET: md5(secret + TIMESTAMP), TIMESTAMP },
    params: {
      baseCode,
      level: 1,
    },
  });
};

export const getBidList = ({ current, size }) => {
  const TIMESTAMP = Math.trunc(new Date().getTime() / 1000);
  return request({
    url: `${prefix}/dat-portal/api/search/queryDwaBids`,
    method: "post",
    headers: { SECRET: md5(secret + TIMESTAMP), TIMESTAMP },
    data: {
      pageNum: current,
      pageSize: size,
    },
  });
};

export const getIntentionList = ({ current, size }) => {
  const TIMESTAMP = Math.trunc(new Date().getTime() / 1000);
  return request({
    url: `${prefix}/dat-portal/api/search/queryDwaIntention`,
    method: "post",
    headers: { SECRET: md5(secret + TIMESTAMP), TIMESTAMP },
    data: {
      pageNum: current,
      pageSize: size,
    },
  });
};
